import {Button, Collapse, Form, InputNumber, message, Tooltip} from "antd";
import React from "react";
import {WasteStreamFilter} from "../../../../filters/WasteStreamCode";
import {WasteStreamGet, WasteStreamPost, WasteStreamRemove, WasteStreamUpdate} from "../../../../models/waste_stream";

const FormItem = Form.Item;
const Panel = Collapse.Panel;

class WasteStreamForm extends React.Component {
  state = {
    data: [],
    update_id: 0
  };
  handleWasteStream = (e) => {
    const form = this.props.form;
    form.validateFields((err, values) => {
      if (!err) {
        WasteStreamPost(values)
          .then(response => {
            this.setState({
              visible: false,
              value: {key: response.id, label: response.name}
            });
            message.success('Waste Stream added successfully');
            this.waste_stream_code.resetValue();
            form.resetFields();
            this.fetchWasteStream(response.id)
          });
      }
    });
  };
  fetchWasteStream = (id) => {
    WasteStreamGet(id)
      .then(response => {
          const data = [...this.state.data, response.data];
          this.setState({
            data: data,
          });
          this.props.onChange(data.map(item => item.id));
        }
      )
  };
  handleChange = (value, update = false) => {
    const ids = value.map(item => item.id);
    if (update) {
      ids.forEach(id => this.fetchWasteStream(id))
    }
    else {
      this.setState({
        data: value,
      });
      this.props.onChange(ids);
    }
  };

  removeWasteStream = (index, id) => {
    const data = this.state.data;
    if(id)
      WasteStreamRemove(id);
    data.splice(index, 1);
    this.handleChange(data)
  };

  getWasteStream = (id, index) => {
    this.removeWasteStream(index);
    this.setState({update_id: id});
    let form = this.props.form;
    WasteStreamGet(id)
      .then(response => {
        form.setFieldsValue({
          quantity: response.data.quantity,
          // price: response.data.price,
          container_size: response.data.container_size
        });
        this.waste_stream_code.handleChange({
          key: response.data.waste_stream.id,
          label: response.data.waste_stream.code + ' - ' + response.data.waste_stream.description + ' - ' + response.data.waste_stream.unit
        });
      });
  }
  updateWasteStream = () => {
    const update_id = this.state.update_id;
    let form = this.props.form;
    form.validateFields((err, values) => {
      if (!err) {
        WasteStreamUpdate(update_id, values)
          .then(response => {
            this.setState({
              visible: false,
              value: {key: response.id, label: response.name}
            });
            message.success('Waste Stream updated successfully');
            this.waste_stream_code.resetValue();
            form.resetFields();
            this.fetchWasteStream(response.id)
            this.setState({update_id: 0})
          });
      }
    });
  }

  componentDidMount() {
    if (this.props.onRef)
      this.props.onRef(this)
  }

  componentWillUnmount() {
    if (this.props.onRef)
      this.props.onRef(null)
  }

  render() {
    const {fields, data, update_id} = this.state;
    const {getFieldDecorator} = this.props.form;
    return (
      <div className="work-perform-collapse">
        <Collapse defaultActiveKey={['1']} className="ws-collapse">
          <Panel key="1" header={<span
            className="add-ws-header">{update_id ? "Update Waste Stream" : "Add Waste Stream"}</span>}>
              <FormItem label="Waste Stream">
                {getFieldDecorator('waste_stream', {
                  rules: [{required: true, message: 'Please select waste stream code'}],
                })(<WasteStreamFilter service_type={this.props.service_type} onRef={ref => (this.waste_stream_code = ref)} {...fields} />)}
              </FormItem>
              <FormItem label="Quantity">
                <Tooltip title="Estimated gallons picked up">
                  {getFieldDecorator('quantity', {})(<InputNumber placeholder="Quantity" {...fields} min={1}/>)}
                </Tooltip>
              </FormItem>
              {/*<FormItem label="Price">*/}
                {/*{getFieldDecorator('price', {})(<InputNumber placeholder="Price" min={0} step={0.1} {...fields} />)}*/}
              {/*</FormItem>*/}
              <FormItem label="# of Containers">
                {getFieldDecorator('container_size', {})(<InputNumber placeholder="Containers" {...fields} />)}
              </FormItem>
              <div className="col-12">
                <button type="button" onClick={update_id ? this.updateWasteStream : this.handleWasteStream}
                        className="ant-btn ant-btn-primary m-t-5">
                  <span>{update_id ? "Update Waste Stream" : "Add Waste Stream"}</span>
                </button>
              </div>
          </Panel>
        </Collapse>
        {data.length > 0 && <div className="added-ws-div">
           <p className="ws-data added-ws-h bg-trans">Added Waste Stream</p>
            {data.map((item, index) => (
            <div key={index} className="ws-content">
              <p className="ws-data bg-trans">
                <span className="ws-name">Waste Stream</span>
                <span>Quantity</span>
                {/*<span>Price</span>*/}
                <span>Container #</span>
                <span className="ws-edit">Edit</span>
                <span className="ws-edit">Delete</span>
              </p>
              <p key={index} className="ws-data ws-tbody">
                <span>{item.waste_stream?item.waste_stream.code:''} - {item.waste_stream?item.waste_stream.unit: ''} - {item.waste_stream.container?item.waste_stream.container.name: ''} </span>
                <span>{item.quantity ? item.quantity : '-'}</span>
                {/*<span>{item.price ? item.price : '-'}</span>*/}
                <span>{item.container_size? item.container_size: '-'}</span>
                <span className="ws-edit"><Button className="action-ws-btn" onClick={() => this.getWasteStream(item.id, index)} htmlType='button'><i
                  className="fa fa-edit"/></Button>
                </span>
                <span className="ws-edit">
                <Button className="action-ws-btn" onClick={() => this.removeWasteStream(index, item.id)} htmlType='button'><i
                  className="fa fa-trash"/></Button>
                </span>
              </p>
            </div>
            ))}
        </div>}
      </div>
    )
  }
}

export const WasteStream = Form.create()(WasteStreamForm);



// WEBPACK FOOTER //
// ./src/pages/tracks/quotes/extra/WasteStreamForm.jsx